export default __webpack_public_path__ + "static/media/perfect-badge.c05778cb.png";